import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { passwordLoginRequirementParser, ssoLoginRequirementParser, } from '#validation';
import { SsoLoginParamsResponseSchema } from '#web-service-api/sso';
export const UserGuestConfigSchema = z.object({
    ssoLoginRequirement: ssoLoginRequirementParser,
    passwordLoginRequirement: passwordLoginRequirementParser,
    ssoLoginParams: SsoLoginParamsResponseSchema.nullable(),
    guestInvitationId: z.string(),
});
export class UserGuestConfigResponseDto extends createZodDto(UserGuestConfigSchema) {
}
